import script from "./SogDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SogDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SogDialog.vue?vue&type=style&index=0&id=65041ae9&lang=css"

const __exports__ = script;

export default __exports__